import { Component, OnInit } from '@angular/core';
import { Card } from 'primeng/card';
import { PessoaDetalhe } from '@/shared/components/pessoa/pessoa-detalhe/pessoa-detalhe';
import { Pessoa } from '@/shared/models/pessoa-info.model';
import { Select } from 'primeng/select';
import { FormsModule } from '@angular/forms';
import { PessoaService } from '@/shared/services/pessoa.service';

@Component({
    selector: 'app-dashboard-pre-medico',
    imports: [Card, PessoaDetalhe, Select, FormsModule],
    templateUrl: './dashboard-pre-medico.html',
    styleUrl: './dashboard-pre-medico.scss'
})
export class DashboardPreMedico implements OnInit {
    constructor(private readonly pessoaService: PessoaService) {}

    pessoa: Pessoa | undefined;
    options: any[] | null | undefined;
    selectedComponent: any;

    ngOnInit(): void {
        this.pessoa = this.pessoaService.getPessoa() ?? this.pessoaService.getPessoaReference() ?? undefined;
    }
}
